import React from 'react'
import classNames from 'classnames'

export class ItemOverviewBlock extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            label: this.props.label,
            body: this.props.body
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.label !== nextProps.label || this.state.body !== nextProps.body) {
            this.setState({
                label: nextProps.label,
                body: nextProps.body
            })
        }
    }

    render() {
        if (this.state.body) {
            return (
                <div className="item-overview-block">
                    <div className="item-overview-label">
                        { this.state.label }
                    </div>
                    <div className="item-overview-body" dangerouslySetInnerHTML={{__html: this.state.body}}/>
                </div>
            )
        } else {
            return null
        }
    }
}
